import { IUpdateable } from 'src/pods/system/interfaces';
import { updater } from 'src/utils/ObjectUpdater';

export default class UserModel implements IUpdateable<UserModel> {
    public email!: string;
    public firstName!: string;
    public id!: number;
    public lastName!: string;
    public phoneNumber!: string;
    public profileImage!: string;
    public isActive!: boolean;

    constructor(args?: Partial<UserModel>) {
        Object.assign(this, args);
    }

    public update(obj: Partial<UserModel>): UserModel {
        return updater.update(this, obj);
    }

    public get fullName() {
        return this.firstName + this.lastName;
    }
}
